import {ChangeDetectionStrategy, Component, OnDestroy, ViewChild} from '@angular/core';
import {ContentService} from "../_services/content.service";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {SnackbarService} from "../_services/snackbar.service";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {AuthService} from "../_services/auth.service";
import {LightboxComponent} from "../shared/lightbox/lightbox.component";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {MatSort, Sort} from "@angular/material/sort";
import {AdminService} from "../_services/admin.service";
import {Subscription} from "rxjs";
import {User} from "../_types/user";
import {HiddenMedia} from "../_types/admin";
import {PaginatedResponse} from "../_types/shared";
import {ReducedTimeline} from "../_types/memorybox";

@Component({
    selector: 'app-hidden-media',
    templateUrl: './hidden-media.component.html',
    styleUrl: './hidden-media.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HiddenMediaComponent implements OnDestroy {
    displayedColumns: string[] = ['author', 'author_role', 'img', 'title', 'file_type', 'hidden_status', 'created_date', 'view'];
    dataSource: MatTableDataSource<HiddenMedia> = new MatTableDataSource();
    @ViewChild(MatPaginator) paginator: MatPaginator | null = null;
    @ViewChild(MatSort) sort: MatSort | null = null;
    order_by: string = 'created_date';
    direction: "" | "asc" | "desc" = "desc";
    tableSizeSubscription: Subscription;
    timelineId: number = 0;
    media: HiddenMedia[] = [];
    permission: string = 'No permission';
    page: number = 0;
    limit: number = 15;
    user!: User;
    timeline: ReducedTimeline | undefined;
    loading: boolean = true;
    count: number = 0;
    subtitle: string = 'Hidden Media';
    status: string = 'All'
    largerTable: boolean = false;

    constructor(
        private contentService: ContentService,
        public dialog: MatDialog,
        private route: ActivatedRoute,
        private snackbarService: SnackbarService,
        private router: Router,
        private authService: AuthService,
        private adminService: AdminService
    ) {
        this.authService.getUser().subscribe({
            next: r => {
                this.user = r;
            }
        })
        if (window.innerWidth < 1600 && window.innerWidth > 1100) {
            this.limit = 16;
        }
        route.queryParams.subscribe(
            (data: Params): void => {
                if (data['hidden_status']) {
                    this.status = data['hidden_status']
                }
                if (data['direction']) {
                    this.direction = data['direction']
                }
                if (data['order_by']) {
                    this.order_by = data['order_by']
                }
                if (data['page']) {
                    this.page = data['page']
                }
                if (data['limit']) {
                    this.limit = data['limit']
                }
            })
        this.route.params.subscribe({
            next: params => {
                if (params && params['timeline']) {
                    this.timelineId = params['timeline'];
                    this.getMedia();
                    if (this.timelineId) {
                        this.contentService.viewTimeline(this.timelineId).subscribe({
                            next: r => {
                                this.timeline = r;
                                this.subtitle = (this.authService.getDisplayName(r, undefined, undefined, 'timeline')) + '\'s Hidden Media';

                            }, error: error => {
                                this.snackbarService.openSnackBar(error, 'error')
                                console.error(error)
                            }
                        });

                    }
                    if (params['index']) {
                        this.viewImage(params['index'])
                    }
                } else {
                    // this.status = 'approval'
                    this.getMedia();
                }
            }, error: error => {
                this.snackbarService.openSnackBar(error, 'error')
                console.error(error)
            }
        });


        this.largerTable = this.adminService.largeTable;
        this.tableSizeSubscription = this.adminService.largeTableChange.subscribe((value: boolean): void => {
            this.largerTable = value;
        });
    }

    ngOnDestroy(): void {
        if (this.tableSizeSubscription) {
            this.tableSizeSubscription.unsubscribe();
        }
    }

    getMedia(): Promise<any> {
        return new Promise((resolve, reject): void => {
            this.loading = true;
            let filters: any = {
                hidden_status: null,
            }

            if (this.status && this.status != 'All') {
                filters.hidden_status = this.status;
            }

            if (this.order_by) {
                filters.order_by = this.order_by
            }
            if (this.direction) {
                filters.direction = this.direction
            }

            filters.page = this.page;
            filters.limit = this.limit;
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: filters,
                queryParamsHandling: 'replace',
                replaceUrl: true
            });

            if (this.timelineId) {
                this.contentService.getHiddenMedia(this.timelineId, filters).subscribe({
                    next: r => {
                        this.processMedia(r)
                        resolve('Success')
                    }, error: error => {
                        this.snackbarService.openSnackBar(error, 'error')
                        console.error(error)
                        this.loading = false;
                        reject(error)
                    }
                });
            } else if (this.user?.role?.role_type === 'admin') {
                if (!this.displayedColumns.includes('memoryBox')) {
                    this.displayedColumns.unshift('memoryBox');
                }
                this.adminService.getAllHiddenMedia(filters).subscribe({
                    next: r => {
                        this.processMedia(r)
                        resolve('Success')
                    }, error: error => {
                        this.snackbarService.openSnackBar(error, 'error')
                        console.error(error)
                        this.loading = false;
                        reject(error)
                    }
                });
            } else {
                this.snackbarService.openSnackBar('You must be an admin to view all users hidden media. Please go to a specific user`s hidden media.', 'error')
            }
        });
    }

    processMedia(r: PaginatedResponse<HiddenMedia>): void {
        this.count = r.count;
        this.media = [];
        for (let media of r.results) {
            this.media.push(media)
        }
        this.dataSource = new MatTableDataSource(this.media);

        this.loading = false;
        if (this.timelineId && !this.permission) {
            this.contentService.viewTimelinePermissions(this.timelineId).subscribe({
                next: r => {
                    for (let permission of r) {
                        if (permission.user.id == this.user.id) {
                            this.permission = permission.permission
                        }
                    }
                    if (!this.permission || this.permission == 'No permission' && this.user?.role?.role_type !== 'admin') {
                        this.snackbarService.openSnackBar('Sorry you do not have permission to view this memory', 'error');
                        this.router.navigate(['/noAccess']);
                    }
                }, error: error => {
                    this.snackbarService.openSnackBar(error, 'error')
                    console.error(error)
                    this.router.navigate(['/noAccess']);
                }
            });
        }
    }

    back(): void {
        if (history.length > 1) {
            history.back();
        } else {
            this.router.navigate(['/timeline']);
        }
    }

    viewImageWithoutIndex(media: any): void {
        let i: number = this.media.findIndex((x: any): boolean => x == media);
        if (i >= 0) {
            this.viewImage(i);
        }
    }

    viewImage(i: number): void {
        // stop all active media
        document.querySelectorAll('video').forEach(vid => vid.pause());
        document.querySelectorAll('audio').forEach(vid => vid.pause());

        let isUsersOwnFavourites: boolean = this.timeline?.owner?.id == this.user.id;
        this.dialog.closeAll();
        if (this.media[i]) {
            const dialogRef: MatDialogRef<LightboxComponent> = this.dialog.open(LightboxComponent, {
                data: {
                    media: this.media,
                    index: i,
                    permission: this.permission,
                    canFavourite: isUsersOwnFavourites,
                },
                panelClass: 'fullWidthWindow',
            });
            dialogRef.componentInstance.refresh.subscribe((index): void => {
                // Refresh favourites if when media changes
                this.getMedia().then((): void => {
                    dialogRef.close();
                    if (index != undefined) this.viewImage(index)
                });
            });
            dialogRef.componentInstance.reFetch.subscribe((): void => {
                // Refresh favourites if when media changes
                this.getMedia().then((): void => {
                    dialogRef.close();
                });
            });
        }
    }

    handlePageEvent(e: PageEvent): void {
        this.page = e.pageIndex;
        this.limit = e.pageSize;
        this.getMedia();
    }

    sortData(event: Sort): void {
        this.page = 0;
        this.order_by = event.active;
        this.direction = event.direction;
        this.getMedia()
    }

}
